import { Component } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-comprehensive-health-panel',
  imports: [UpsellCardComponent],
  templateUrl: './comprehensive-health-panel.component.html',
})
export class ComprehensiveHealthPanelComponent {
  public readonly slug: UpsellSlugs = UpsellSlugs.ComprehensiveHealthPanel;
}
